exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.panel-head.locations[data-v-79ad9f64]{color:white;display:inline-flex;flex-direction:row;z-index:10;background:#a5097e;position:relative;color:white\n}\nh2[data-v-79ad9f64]{padding:0 1rem\n}\n", ""]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79ad9f64","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"includePaths":["/home/runner/work/parks-rec-finder/parks-rec-finder/node_modules/foundation-sites/scss"]}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/parks-rec-finder/parks-rec-finder/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Locations.vue
// module id = 705
// module chunks = 0